// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"cbb18ed4","232":"ccb4d179","237":"40587d98","526":"470d5a94","787":"d5081387","872":"7399083a"}[chunkId] + ".chunk.js";
};